import React from 'react'
import {EmployerProfile} from '../Pages/Employer/EmployerProfile/EmployerProfile'

function Employerprofile() {
  return (
    <>
        <EmployerProfile />
    </>
  )
}

export default Employerprofile
